import React, { useState } from "react";
import { Alert, AlertTitle, Box, Stack } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import PDFReader from "./PDFReader";
import BasicCheckbox from "../Base/BasicCheckbox";
import SubmitButton from "../common/SubmitButton";
import configData from "../../Config";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/termsAndCon.module.css";
import "../../Style/Theme/index.css";
import Backdrop from "./Backdrop";
import AlertPopup from "./AlertPopup";
import LoadingDots from "../Lottie/LoadingDots";
import { CONSTANTS } from "../../utils/constant";

const Terms = () => {
  const [Agree, setAgree] = React.useState(false);
  const [Sanction, setSantion] = React.useState(false);
  const [KFS, setKFS] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  const initialCheckedData = {
    DocTnC: false,
    DocLoanAccount: false,
  };
  const [checkformData, setCheckFormData] = useState(initialCheckedData);
  const navigate = useNavigate();
  let location = useLocation();

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        aid: location.state.AppId,
        did: location.state.R,
      };

      let resp = await apis.postApi(
        configData.API_URL + "Aggrement/SignTerms",
        reqData
      );
      let result = await resp.json();
      if (resp?.status === 200) {
        let checkStageData = JSON.parse(result?.data?.stageData);
        setLoading(false);
        let data = {
          mn: result?.data?.mobile,
          AppId: location.state.AppId,
          em: "",
          isEmail: false,
          DocTnC: checkformData?.DocTnC,
          DocLoanAccount: checkformData?.DocLoanAccount,
          IsLimitEnhacement_Reduction:
            checkStageData?.IsLimitEnhacement_Reduction,
        };
        navigate("/otp_f", { state: data });
      }
    } catch (error) {
      //console.log(err);
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };
  let handleCheckOne = (e) => {
    setCheckFormData({
      ...checkformData,
      [e?.target?.name]: e?.target?.checked,
    });
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <Box>
      <Box>
        <PDFReader
          file={"data:application/pdf;base64," + location.state.A}
          showToolBar={true}
          setSVal={setKFS}
        />
        <PDFReader
          file={"data:application/pdf;base64," + location.state.B}
          showToolBar={true}
          setSVal={setSantion}
        />
        <PDFReader
          file={"data:application/pdf;base64," + location.state.C}
          showToolBar={true}
          setSVal={setAgree}
        />
      </Box>
      <Box>
        <form onSubmit={handleSubmit}>
          <div mb={-2} mt={-222}>
            <div className={styles.termsAndConBox}>
              <BasicCheckbox
                name="DocTnC"
                checked={checkformData?.DocTnC}
                label={"I agree to the terms & conditions"}
                onChange={handleCheckOne}
              />
            </div>
          </div>

          <div mb={100}>
            <div className={styles.termsAndConBox}>
              <BasicCheckbox
                name="DocLoanAccount"
                checked={checkformData?.DocLoanAccount}
                onChange={handleCheckOne}
                label={
                  "I agree that Loan account will be opened only after successful completion of customer identification procedure as per RBI guidelines."
                }
              />
              <ul
                className={styles.termsAndConBox}
                style={{ listStyle: "none" }}
              >
                <li className="subTitle_Th">
                  In case of any mismatch in my personal data captured in PAN
                  and Aadhar/ any other identity proof, I authorize{" "}
                  {CONSTANTS?.brandName?.smallCase} Capital Pvt. Ltd. to use and
                  update its records as per my details captured in PAN card.
                </li>
                <br></br>
                <li className="subTitle_Th">
                  I hereby authorize {CONSTANTS?.brandName?.smallCase} Capital
                  Pvt. Ltd. to fetch my Central KYC Records (CKYCR) and treat
                  the information contained therein as correct and up to date.I
                  further undertake to inform {CONSTANTS?.brandName?.smallCase}{" "}
                  Capital Pvt. Ltd. in case of any change in details.
                </li>
              </ul>
            </div>
          </div>

          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <SubmitButton
            hasNote="No"
            disabled={!checkformData?.DocTnC || !checkformData?.DocLoanAccount}
          />
        </form>
      </Box>
      {loading && (
        <Backdrop ax="center">
          <LoadingDots />
        </Backdrop>
      )}
      {finalErr && (
        <Backdrop ax="center">
          <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
        </Backdrop>
      )}
    </Box>
  );
};

export default Terms;
